var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBankAccountIbanIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 17.597,
    viewBox: "0 0 22 17.597",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "money-bill-transfer-solid_1_",
    "data-name": "money-bill-transfer-solid (1)",
    d: "M18.393,1.494A.824.824,0,0,1,19.559.329l2.2,2.2a.83.83,0,0,1,0,1.169l-2.2,2.2a.824.824,0,0,1-1.165-1.165l.791-.791L13.2,3.935a.825.825,0,0,1,0-1.65h5.986ZM3.61,13.046l-.791.791H8.8a.825.825,0,1,1,0,1.65H2.816l.791.791a.824.824,0,1,1-1.165,1.165l-2.2-2.2a.83.83,0,0,1,0-1.169l2.2-2.2a.824.824,0,0,1,1.165,1.165ZM3.3,2.285h8.317A1.786,1.786,0,0,0,13.2,4.9h4.036a1.787,1.787,0,0,0,3,1.678l.664-.664v7.375a2.2,2.2,0,0,1-2.2,2.2H10.386A1.786,1.786,0,0,0,8.8,12.874H4.765a1.787,1.787,0,0,0-3-1.678L1.1,11.86V4.485A2.2,2.2,0,0,1,3.3,2.285Zm2.2,2.2H3.3v2.2A2.2,2.2,0,0,0,5.5,4.485Zm13.2,6.6a2.2,2.2,0,0,0-2.2,2.2h2.2Zm-7.7,1.1a3.3,3.3,0,1,0-3.3-3.3A3.3,3.3,0,0,0,11,12.186Z",
    transform: "translate(0 -0.087)",
    fill: "#21827f"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankAccountIbanIcon);
export default __webpack_public_path__ + "static/media/bank-account-iban-icon.1ddc763a5a753b4e4590cd29a3f83f90.svg";
export { ForwardRef as ReactComponent };